import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Modal.css';

const Modal = ({ show, onClose, children }) => {
    useEffect(() => {
        if (show) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }

        // Cleanup function to remove class when component unmounts
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div style={{display:'flex',justifyContent:'flex-end',}}>
                    <FontAwesomeIcon
                        icon="times"
                        className="modal-close-icon"
                        onClick={onClose}
                        color='black'
                        style={{
                            cursor: 'pointer',
                            borderRadius:'50%',
                            backgroundColor:'red',
                            paddingTop:3,
                            paddingBottom:3,
                            paddingLeft:5,
                            paddingRight:5,
                        }}
                    />
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;
